import moment from "moment";
import { toast } from "react-hot-toast";
import { channelController } from "../../../../controllers/channelController";
import { Dropdown, Space, Table, Tag, Button } from "antd";
import { TbDotsVertical } from "react-icons/tb";
import axios from "../../../../utils/axios";
import { FcCalendar } from "react-icons/fc";
import { MoreOutlined } from "@ant-design/icons";

import { useState } from "react";
import { formatName } from "../../../../utils/helpers";
import { AppLoader } from "../../../AppLoader";
import ConfirmationModal from "../../../Settings/Modals/ConfirmationModal";
import { errorBlock } from "../../../../controllers/errorBlock";
import { UserProfileUpdate } from "../../../Dashboards/SystemAdmin/Modal/UserProfileUpdate";

const UserTable = ({ data, refreshBtn }) => {
  const [username, setUsername] = useState("");
  const [modal, setmodal] = useState(false);
  const [selecteduser, setSelecteduser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleActivate = async (item) => {
    try {
      if (!item?.username) {
        toast.error("Please select a username");
        return;
      }
      setLoading(true);
      let res = await axios.post("/auth/activateuseraccount", {
        username: item?.username,
      });
      let result = channelController(res);
      if (result.type !== "success") {
        toast[result.type](result.message);
        setLoading(false);
        return;
      }
      setMsg("Activating user account");
      toast.success("Account deactivated successfully.");
      setLoading(false);
      refreshBtn((prev) => !prev);
    } catch (err) {
      setLoading(false);
      // toast.error(err.message);
      errorBlock(err);
    }
  };

  const handleDeactivate = async () => {
    try {
      if (!selecteduser?.username) {
        toast.error("Please select a username");
        return;
      }
      setLoading(true);
      let res = await axios.post("/auth/deactivateuseraccount", {
        username: selecteduser?.username,
      });
      let result = channelController(res);
      if (result.type !== "success") {
        toast[result.type](result.message);
        setLoading(false);
        return;
      }
      setMsg("Activating user account");
      toast.success("Account deactivated successfully.");
      setLoading(false);
      refreshBtn((prev) => !prev);
    } catch (err) {
      errorBlock(err);
      setLoading(false);
      // toast.error(err.message);
    }
  };

  const columns = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      align: "center",
      render: (username) => <Tag color="blue">{username ?? "Nil"}</Tag>,
    },
    {
      title: "Name",
      key: "name",
      align: "center",
      sorter: true,
      render: (_, record) => (
        <div>
          {!record?.firstname
            ? "-"
            : formatName(record?.firstname) +
              " " +
              formatName(record?.lastname)}
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
      sorter: true,
      render: (email) => (
        <div>
          {email ?? (
            <span className="text-blue-500">Incomplete registration</span>
          )}
        </div>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      align: "center",
      render: (phone) => <div>{phone ?? "-"}</div>,
    },
    {
      title: "Active Status",
      dataIndex: "activestatus",
      key: "activestatus",
      align: "center",
      sorter: true,
      render: (activestatus) => (
        <Tag color={activestatus === "active" ? "success" : "error"}>
          {activestatus}
        </Tag>
      ),
    },
    {
      title: "Date Registered",
      dataIndex: "dateregistered",
      key: "dateregistered",
      align: "center",
      sorter: true,
      render: (dateregistered) => (
        <div className="flex items-center justify-center">
          <div className="px-1">
            <FcCalendar size={18} />
          </div>
          <div className="text-xs">{moment(dateregistered).format("lll")}</div>
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: (
                  <div>
                    {record.activestatus === "active" ? (
                      <div
                        onClick={() => {
                          setSelecteduser(record);
                          setmodal(true);
                        }}
                      >
                        Deactivate
                      </div>
                    ) : (
                      <div onClick={() => handleActivate(record)}>Activate</div>
                    )}
                  </div>
                ),
              },
              {
                key: "2",
                label: (
                  <div
                    onClick={() => {
                      setSelecteduser(record);
                      setIsModalVisible(true);
                    }}
                  >
                    Update Account
                  </div>
                ),
              },
            ],
          }}
          placement="bottomRight"
          arrow
        >
          <Button
            type="text"
            icon={<MoreOutlined />}
            onClick={(e) => e.preventDefault()}
          />
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      {modal && (
        <ConfirmationModal
          loading={loading}
          title={"Account Deactivation"}
          description={`Are you sure you want to deactivate this user's account? This action will temporarily suspend all account activities, including access to services and functionalities. The user will no longer be able to perform any actions until the account is reactivated. Type <span class="bg-gray-100 rounded-md px-[4px] cursor-pointer">I understand</span> to continue.`}
          isModalOpen={modal}
          setIsModalOpen={setmodal}
          handleContinue={handleDeactivate}
        />
      )}
      {isModalVisible && (
        <UserProfileUpdate
          refreshBtn={refreshBtn}
          visible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          selecteduser={selecteduser}
        />
      )}
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          pageSize: 10,
          showSizeChanger: false,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        size="small"
        rowKey={(record) => record.username || record.email}
        scroll={{ x: 1000 }}
        className="cursor-pointer"
      />
    </>
  );
};

export default UserTable;
